import { AxiosRequestConfig } from 'axios';
import { ChatMessage, ChatOrder, ChatRoom } from '../domain/chat';
import { apiClient } from './client';
import { withAuthorizationHeader } from './auth';
import { stringify } from 'qs';
import { EntityType } from '../domain/entity';
import { ListResponse } from '../domain/list';

export type CreateChatPayload = {
  marketId: string;
  cooperativeId: string;
};

export const createChatRoom = async (
  token: string,
  payload: CreateChatPayload,
  opts: AxiosRequestConfig = {},
): Promise<ChatRoom> => {
  const response = await apiClient.post<ChatRoom>(
    `/v1/chats`,
    payload,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};

export type CreateChatMessage = {
  senderId: string;
  receiverId: string;
  message: string;
};

export const sendChatMessage = async (
  token: string,
  roomId: string,
  payload: CreateChatMessage,
  opts: AxiosRequestConfig = {},
): Promise<ChatMessage> => {
  const response = await apiClient.post<ChatMessage>(
    `/v1/chats/${roomId}/messages`,
    payload,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};

export const searchChatRooms = async (
  token: string,
  entityId: string,
  entityType: EntityType,
  opts: AxiosRequestConfig = {},
): Promise<ListResponse<ChatRoom>> => {
  const queryString = stringify({
    entityId,
    entityType,
  });
  const response = await apiClient.get<ListResponse<ChatRoom>>(
    `/v1/chats?${queryString}`,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};

export const searchChatMessages = async (
  token: string,
  roomId: string,
  opts: AxiosRequestConfig = {},
): Promise<ListResponse<ChatMessage>> => {
  const response = await apiClient.get<ListResponse<ChatMessage>>(
    `/v1/chats/${roomId}/messages`,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};

export const getChatOrders = async (
  token: string,
  roomId: string,
  opts: AxiosRequestConfig = {},
): Promise<ListResponse<ChatOrder>> => {
  const response = await apiClient.get<ListResponse<ChatOrder>>(
    `/v1/chats/${roomId}/orders`,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};
